import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=1ffdc084&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"
import style0 from "./HomeNews.vue?vue&type=style&index=0&id=1ffdc084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffdc084",
  null
  
)

export default component.exports